import { takeEvery, put, fork, call, all /*select*/ } from 'redux-saga/effects';
import { actions as provReducerActions, callTypes as provReducerCallTypes } from "./provinceSlice"
import { getAllProvincesApi, searchProvincesApi, getProvincesInRegionApi } from "./provinceAPI";
import * as uis from "../../../UI/redux/uiSlice";
import { sortProvinces } from '../../../../utils/sortProvinces';
import logman from '../../../../../utilities/logman';

export function* onLoadProvincesStartAsync(){

    try{
        
        yield put(provReducerActions.startCall({ callType: provReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);
        
        // let reqBody = {
        //     username: "guest",
        //     sessionkey: auth.sessionKey,
        // };

        // const response = yield call(getAllProvincesApi, reqBody);

        const response = yield call(getAllProvincesApi);        

        if(response.status === 200){
            let sortedProvinces = sortProvinces(response.data);
            let entities = sortedProvinces;
            let totalCount = entities.length;
            yield put(provReducerActions.provincesLoaded({entities, totalCount}));
        }
    }
    catch(error){
        logman.log(error)
        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the departments."
        // }));

        yield put(provReducerActions.catchError({
            callType: provReducerCallTypes.list,
            error: "There was an error retrieving the provinces."
        }));

    }

};

export function* onSearchProvincesStartAsync({payload}){

    try{
        
        yield put(provReducerActions.startCall({ callType: provReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     string: payload.query
        // };

        // const response = yield call(searchProvincesApi, reqBody);
        
        let queryObj = { str: payload.query.str };
        let regionId = payload.query.regionId;

        const response = yield call(searchProvincesApi, queryObj);       
        
        if(response.status === 200){
            let data = response.data ? response.data : [];
            let totalCount = data.length;
            //filter by region id
            let entities = data.filter((prov) => prov.region_id === regionId);
            yield put(provReducerActions.provincesLoaded({entities, totalCount}));
        }
    }
    catch(error){
        
        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error while searching for the departments."
        // }));

        yield put(provReducerActions.catchError({
            callType: provReducerCallTypes.list,
            error: "There was an error while searching for the provinces."
        }));

    }

};

export function* onLoadProvincesByRegionStartAsync({payload}){

    try{
        
        yield put(provReducerActions.startCall({ callType: provReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);
        
        // let reqBody = {
        //     username: "guest",
        //     sessionkey: auth.sessionKey,
        // };

        // const response = yield call(getAllProvincesApi, reqBody);
        
        const response = yield call(getProvincesInRegionApi, payload.regionId);        
        
        if(response.status === 200){
            let entities = response.data ? response.data : [];
            let totalCount = entities.length;
            yield put(provReducerActions.provincesLoaded({entities, totalCount}));
        }
    }
    catch(error){
        logman.error(error)
        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the provinces."
        // }));

        yield put(provReducerActions.catchError({
            callType: provReducerCallTypes.list,
            error: "There was an error retrieving the provinces."
        }));

    }

};

export const actionTypes = {
    FetchAllProv: "[FetchAllProv] Fetch All Provinces API Action",
    SearchProv: "[SearchProv] Search Provinces API Action",
    FetchAllProvInRegion: "[FetchAllProvInRegion] Fetch All Provinces In Region API Action",
};

export const actions = {

    fetchAllProv: () => ({ type: actionTypes.FetchAllProv, payload: { undefined } }),
    searchProvinces: (query) => ({ type: actionTypes.SearchProv, payload: { query } }),
    fetchAllProvInRegion: (regionId => ({ type: actionTypes.FetchAllProvInRegion, payload: regionId })),

};

export function* fetchAllProvinces(){

    yield takeEvery(actionTypes.FetchAllProv, onLoadProvincesStartAsync);    
};

export function* searchProvinces(){

    yield takeEvery(actionTypes.SearchProv, onSearchProvincesStartAsync);    
};

export function* fetchAllProvInRegion(){

    yield takeEvery(actionTypes.FetchAllProvInRegion, onLoadProvincesByRegionStartAsync);    
};


const fSagas = [
    fork(fetchAllProvinces),
    fork(searchProvinces),
    fork(fetchAllProvInRegion),

];

export function* saga(){
    yield all ([...fSagas]);
};
